import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import UrlParamsUtil from '../../../services/util/UrlParamsUtil';
import UserActions from '../../../store/userRedux';

class LanguageInitializer extends Component {

    componentDidMount() {
        let parsedParams = UrlParamsUtil.getQueryParams(window.location.search);

        if (parsedParams.lang) {
            this.props.setLanguage(parsedParams.lang);
        }
        this.props.updateState('languageInitializer');
    }

    render() {
        return (
            <div></div>
        );
    }
}

LanguageInitializer.propTypes = {
    updateState: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
    setLanguage: (language) => dispatch(UserActions.setLanguage(language))
})

export default connect(
    null,
    mapDispatchToProps
)(LanguageInitializer);